import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, post } from "../../api/api";
import { setLoading } from "../../app/loadingSlice";

//Call fetch users api request
export const fetchIndicatorsList = createAsyncThunk(
    "indicator/list",
    async (finalObj: object, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post(`/indicator/list`, finalObj);
            return response.data;
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setLoading(false));
        }
    }
);

// File upload API call using multipart/form-data
export const uploadFile = createAsyncThunk(
    "file/upload",
    async (formData: FormData, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post("/indicator/upload", formData, {
                headers: {
                    "Content-Type": "multipart/form-data", // Make sure the Content-Type is correct
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            throw error;
        } finally {
            dispatch(setLoading(false));
        }
    }

);

// File download API call
export const downloadFile = createAsyncThunk("/download", async (indicatorId: number, { dispatch }) => {
    dispatch(setLoading(true));

    try {
        const response = await post('/download', { id: indicatorId }, {
            responseType: 'blob', // Ensure the response is a Blob
        });

        if (response.data instanceof Blob) {
            // Extract filename from headers if available
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'downloaded_file.xlsx'; // Default file name if none is found

            // Extract filename from Content-Disposition header
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename(?:\*=UTF-8'')?=([^\s;]+)/);

                if (filenameMatch && filenameMatch[1]) {
                    fileName = filenameMatch[1];
                }
            }

            // Now you can use the fileName for your download
            const blobUrl = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;  // Use the extracted filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl);

        } else {
            console.error('Received data is not a Blob.');
        }

    } catch (error) {
        console.error('File download failed:', error);
    } finally {
        dispatch(setLoading(false));
    }
});


//Call delete users api request
export const deleteIndicatorsData = createAsyncThunk(
    "indicator/delete",
    async (finalObject: object, { dispatch }) => {
        dispatch(setLoading(true));
        try {
            const response = await post(`/indicator/delete`, finalObject);
            return response.data;
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(setLoading(false));
        }
        dispatch(setLoading(false));

    }
);

//Call fetch users api request
export const fetchUsers = createAsyncThunk("users", async (_, { dispatch }) => {
    dispatch(setLoading(true));
    try {
        const response = await get("/users")
        return response;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        dispatch(setLoading(false));
    }
});